import { UAParser } from 'ua-parser-js';

export const isIos = () => {
  const parser = new UAParser();
  const os = parser.getOS();
  return os.name === 'iOS';
};
